<section>
  <div *ngIf="showTickets">
    <div style="margin-top: 5%">
      <div class="row mt-4 mobile-ticket-card">
        <div
          #seatmap
          *ngIf="(!showCartMobile && isMobile) || !isMobile"
          class="col-lg-7 col-md-12 col-12"
        >
          <!-- <si-seatsio-seating-chart
            divId="chart"
            *ngIf="eventManagerConfig"
            [config]="eventManagerConfig"
          ></si-seatsio-seating-chart> -->
          <si-seatsio-seating-chart
            [divId]="chart"
            class="custom-height"
            [config]="eventManagerConfig"
            *ngIf="ticketPricingObject && ticketPricingObject.length > 0"
          ></si-seatsio-seating-chart>
        </div>
        <div
          class="col-lg-4 offset-lg-1 col-md-12 col-12 cart-container"
          *ngIf="!isMobile || (showCartMobile && isMobile)"
        >
          <div
            *ngIf="
              this.ticketService?.bookTicket?.getValue()?.items?.length == 0 ||
              !this.ticketService?.bookTicket?.getValue()?.items
            "
          >
            <div style="justify-items: center">
              <img src="assets/images/tickets/no-tickets.png" />
              <div class="cart-container__empty-text">
                {{ "no-ticket" | translate }}
              </div>
            </div>
          </div>
          <div
            *ngIf="
              this.ticketService?.bookTicket?.getValue()?.items?.length > 0
            "
          >
            <div class="cart">
              <app-cart></app-cart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
